/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
import Autocomplete from '@mui/material/Autocomplete';
import { createStyles, makeStyles } from '@mui/styles';
import React, { useEffect, useMemo, useState } from 'react';
import InputField from '../InputField/NewInputField';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiAutocomplete-listbox': {
        marginBottom: 40,
        '& li:nth-child(n)': {
          borderBottom: '1px solid black',
          fontSize: '14px',
        },
      },
      '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
        color: 'black',
      },
      '& .MuiInput-root.MuiInput-underline': {
        borderBottom: 'none',
      },
      '& .MuiFormLabel-root': {
        color: 'rgba(0, 0, 0, 0.7)',
        fontWeight: 400,
        fontSize: 14,
        transform: 'translate(16px, 11px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(16px, -9px) scale(0.75)',
        },
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: 'rgba(0, 0, 0, 0.7)',
        transform: 'translate(16px, -9px) scale(0.75)',
      },
      '& .MuiFormLabel-filled': {
        color: 'rgba(0, 0, 0, 0.7)',
        transform: 'translate(16px, -9px) scale(0.75)',
      },
      '& .MuiChip-deleteIcon': {
        display: 'none',
      },
      '& .MuiChip-root': {
        background: 'none',
      },
      '& .MuiAutocomplete-inputRoot': {
        flexWrap: 'nowrap !important',
      },
      '& .MuiChip-label': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: '3px',
        paddingRight: '0px',
        whiteSpace: 'nowrap',
        maxWidth: '60px',
      },
    },
  })
);

function AutoCompleteDropdown({
  getOptionLabel,
  options = [],
  label,
  name,
  value,
  onChange,
  inputProps,
  disabled = false,
  useHiddenInput = false,
  multiple = false,
  onInputChange,
  ...props
}) {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (!value) {
      setInputValue('');
    }
  }, [value]);

  const classes = useStyles();

  const formattedValue = useMemo(() => {
    if (multiple) {
      return options?.filter((opt) => value?.includes(opt.value)) ?? [];
    }
    return (
      options?.find(
        (opt) =>
          opt.value === (typeof value === 'string' ? value : Number(value))
      ) ?? null
    );
  }, [options, value, multiple]);

  return (
    <>
      <Autocomplete
        {...props}
        multiple={multiple}
        options={options}
        name={name}
        className={classes.root}
        id="auto-complete-dropdown"
        value={formattedValue}
        isOptionEqualToValue={(option, val) => {
          return option.value === val.value;
        }}
        style={{
          ...(disabled
            ? { backgroundColor: 'rgba(239, 239, 239, 1.5)', borderRadius: 8 }
            : {}),
          ...(props.style ?? {}),
        }}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          if (onInputChange && newInputValue) {
            onInputChange(newInputValue);
          }
        }}
        getOptionLabel={getOptionLabel}
        disabled={disabled}
        renderInput={(params) => (
          <InputField {...params} {...inputProps} label={label} />
        )}
      />
      {useHiddenInput && (
        <input type="hidden" value={value ? Number(value) : ''} name={name} />
      )}
    </>
  );
}

export default AutoCompleteDropdown;
